// @ts-nocheck
import {
  Box,
  Button,
  Flex,
  Title,
  Text,
  TextInput,
  SimpleGrid,
  Stepper,
  Textarea,
  Radio,
  Group,
  Checkbox,
  Skeleton,
} from '@mantine/core';
import { useLocation } from 'react-router-dom';
import { GradientButton } from 'components/GradientButton';
import evaluationImage from 'assets/evaluation/img03a.png';
import bgImage1 from 'assets/evaluation/bg01A.png';
import bgImage2 from 'assets/evaluation/bg02A.png';
import bgImage3 from 'assets/evaluation/bg03A.png';
import bgImage4 from 'assets/evaluation/bg04A.png';
import { useQuery } from '@tanstack/react-query';
import { API } from 'services';
import { useForm } from '@mantine/form';
import Swal from 'sweetalert2';
import { Outlet, useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import { IconBulb } from '@tabler/icons-react';
import SignatureCanvas from 'react-signature-canvas';
import {
  buildOralRecoveryRemark,
  findCommentedRows,
  findNycWithRemarks,
} from 'utils/assessmentRemarks';
import { NycReminder, RemarkReviewModal } from './AssessmentReviewModals';
import { AssessmentSkeleton } from './AssessmentSkeleton';


export function AssessmentPage() {
  
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const assessmentId = queryParams.get('assessment_id');
  const apiUrl = import.meta.env.VITE_API_URL;

  const [active, setActive] = useState(0);

  const [section1, setSection1] = useState([]);

  const [activeTab, setActiveTab] = useState('');
  const handleTabChange = (tab: any) => {
    setActiveTab(tab);
  };

  const assessmentDetail = useQuery(['assessmentDetail'], () => {
    return API.getAssessmentDetail({
      assessment_id: assessmentId,
    }).then((res) => res.data);
  });

  const mandonaly = (
    <span
      className="mantine-103svbs mantine-InputWrapper-required mantine-TextInput-required"
      aria-hidden="true"
    >
      {' '}
      *
    </span>
  );

  const ass = assessmentDetail.data;
  const isLoading = assessmentDetail.isLoading;
  // const signatureRef = useRef(null);
  const signatureRef = useRef<SignatureCanvas | null>(null);

  const form = useForm({
    initialValues: {
      status: {}, // Store trainer comments dynamically
      comments: {}, // Store trainer comments dynamically
      signature: "",
      assessment_comment: "",
    },
    validate: {
      signature: (value, _values) => {
        if (ass?.trainer_signature) {
          return null; // skip validation if existing signature present
        }
  
        if (!value || value.trim() === "") {
          return "Signature is required";
        }
  
        return null;
      },
      status: (_values) => {
        const errors: Record<string, string> = {};
        const values = _values as Record<string, string>;
  
        if (ass && ass.questions) {
          
          Object.values(ass.questions).forEach((question: any) => {
            const mainKey = question.parent_id;
            const statusValue = values[mainKey];
  
            // If there are sub-questions
            if (question.assessment_question_options && question.assessment_question_options.length) {
              question.assessment_question_options.forEach((subQuestion: any) => {
                const subKey = `${question.parent_id}_${subQuestion.sub_id}`;
                if (!values[subKey] || (values[subKey] != "C" && values[subKey] != "NYC")) {
                  errors[subKey] = "Status is required";
                }
              });
            } else {
              if (!values[mainKey] || (values[mainKey] != "C" && values[mainKey] != "NYC")) {
                errors[mainKey] = "Status is required";
              }
            }
          });
        }
        return Object.keys(errors).length ? errors : null;
      },
      comments: (_values, allValues) => {
        const errors: Record<string, string> = {};
        const statusValues = allValues.status as Record<string, string>;
        const commentValues = _values as Record<string, string>; // this refers to `comments`
        
        if (ass && ass.questions) {  
          Object.values(ass.questions).forEach((question: any) => {
        // if (ass && ass.questions) {
        //   ass.questions.forEach((question: any) => {
            const mainKey = question.parent_id;
      
            // Handle sub-questions
            if (question.assessment_question_options?.length) {
              question.assessment_question_options.forEach((subQuestion: any) => {
                const subKey = `${question.parent_id}_${subQuestion.sub_id}`;
                const status = statusValues[subKey];
                const comment = commentValues[subKey];
      
                if (status === "NYC" && (!comment || comment.trim() === "")) {
                  errors[subKey] = "Comment is required for NYC status";
                }
              });
            } else {
              const status = statusValues[mainKey];
              const comment = commentValues[mainKey];
      
              if (status === "NYC" && (!comment || comment.trim() === "")) {
                errors[mainKey] = "Comment is required for NYC status";
              }
            }
          });
        }
      console.log(errors);
        return Object.keys(errors).length ? errors : null;
      },
      // comments: (_values) => {
      //   const errors: Record<string, string> = {};
      //   const values = _values as Record<string, string>; // ✅ Type assertion
  
      //   if (ass && ass.questions) {
      //     Object.values(ass.questions).forEach((question: any) => {
      //       const mainKey = question.parent_id;
      //       // Validate Main Question Comment
      //       if (!values[mainKey]?.trim()) {
      //       // if (!(_values?.[question.parent_id]?.trim())) {
      //         // Validate Sub-Questions using the new key format
      //         if (question.assessment_question_options && question.assessment_question_options.length) {
      //           question.assessment_question_options.forEach((subQuestion: any) => {
      //             const subKey = `${question.parent_id}_${subQuestion.sub_id}`;
      //             // const key = `${question.parent_id}_${subQuestion.sub_id}`;
      //             // if (!(_values?.[key]?.trim())) {
      //             if (!values[subKey]?.trim()) {
      //               errors[subKey] = "Trainer Comment is required";
      //             }
      //           });
      //         }else{
      //           errors[question.parent_id] = "Trainer Comment is required";
      //         }
      //       }
      //     });
      //   }
        
      //   return Object.keys(errors).length ? errors : null;
      //   // return null;
      // },
    },  
  });

  const formRef = useRef(form);
  formRef.current = form;

  const questionList = ass?.questions ? Object.values(ass.questions) : [];
  const suggestedRemark = buildOralRecoveryRemark(questionList, form.values.comments);
  const isRemarkEmpty = !form.values.assessment_comment?.trim();

  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [remarkDraft, setRemarkDraft] = useState('');

  const commentedRows = findCommentedRows(questionList, form.values.status, form.values.comments);
  const nycRows = findNycWithRemarks(questionList, form.values.status, form.values.comments);

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    if (isRemarkEmpty && suggestedRemark) {
      setRemarkDraft(suggestedRemark);
      setRemarkModalOpen(true);
      return;
    }

    form.onSubmit(handleSubmitSection1)();
  };

  const continueSubmit = () => {
    setRemarkModalOpen(false);
    // let any new remark render so validation sees it
    setTimeout(() => formRef.current.onSubmit(handleSubmitSection1)(), 0);
  };

  const handleAddRemark = () => {
    form.setFieldValue('assessment_comment', remarkDraft.trim());
    continueSubmit();
  };

  const handleSubmit = async () => {
    // Capture signature before validation
    if (!ass?.trainer_signature && signatureRef.current && !signatureRef.current.isEmpty()) {
      const signatureData = signatureRef.current.toDataURL();
      form.setFieldValue("signature", signatureData);
    }
  
    // Wait for value to be set before validating
    setTimeout(() => {
      const isValid = form.validate();
      if (!isValid.hasErrors) {
        // proceed with submit
        console.log(form.values);
      }
    }, 0);
  };
  

  const showSubmissionResult = (response: any) => {
    if (response.data.status) {
      Swal.fire({
        title: 'Thank you!',
        text: 'Your submission has been received.',
        icon: 'success',
        confirmButtonText: 'OK',
      }).then(() => {
        // Optional: go to next step/page after the alert is closed
        // setActive(5);
        navigate(`/course?course=${ass.courserun_course_id}&course_run=${ass.courserun_id}&first_tab=trainer&second_tab=assessment`);
        // window.location.reload();
      });
    } else {
      // Show error with SweetAlert
      Swal.fire({
        title: response.data.title || 'Error',
        text: response.data.message || 'Something went wrong.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const handleSubmitSection1 = (data: any) => {
    Swal.fire({
      title: 'Are you sure?',
      // text: 'After submission, you will not be able to edit your response.',
      text: 'Please confirm that you want to update the assessment record',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, submit it!',
      cancelButtonText: 'Cancel',
      // keep the dialog open with a spinner on the confirm button until the API responds
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
      preConfirm: () =>
        API.assessmentSubmission({
          data: data,
          assessment_id: assessmentId,
        } as any).catch(() => {
          Swal.showValidationMessage('Submission failed. Please try again.');
          return false;
        }),
    }).then((result) => {
      if (result.isConfirmed && result.value?.data) {
        showSubmissionResult(result.value);
      }
    });
  };

  const handleClearSignature = () => {
    signatureRef.current?.clear();
  };

  // const handleSaveSignature = () => {
  //   if (signatureRef.current && !signatureRef.current.isEmpty()) {
  //     const signatureData = signatureRef.current.toDataURL();
  //     form.setFieldValue("signature", signatureData);
  //   }
  // };

  useEffect(() => {
    if (ass && ass.questions) {
      // const status = {};
      // const comments = {};
      const status: Record<string, boolean> = {};
      const comments: Record<string, boolean> = {};
  
      Object.values(ass.questions).forEach((q: any) => {
          
          if (q.assessment_question_options && q.assessment_question_options.length) {
              q.assessment_question_options.forEach((subQuestion: any) => {
                const key = `${q.parent_id}_${subQuestion.sub_id}`;
                status[q.parent_id+"_"+subQuestion.sub_id] = subQuestion.status;
                // status[q.parent_id+"_"+subQuestion.sub_id] = subQuestion.status === "Pass";
                comments[q.parent_id+"_"+subQuestion.sub_id] = subQuestion.comment;
            });
          }else{
            status[q.parent_id] = q.status;
            // status[q.parent_id] = q.status === "Pass";
            comments[q.parent_id] = q.comment;

          }
      });
      
      form.setValues({
        status: status,
        comments:comments,
        assessment_comment: ass.assessment_comment
      });
    }
  }, [ass]);

  
  return (
    <Box bg="#f4fafe" w="100%" h="100vh" className="evalution_box"
      sx={{
        'table, tbody, td, tfoot, th, thead, tr': {
          borderColor: '#010',
          borderWidth: '1px',
          padding: '5px'
        },
    }}
    >
      <SimpleGrid
        cols={2}
        bg="#e5f7f2"
        className="evalution_question_box"
        p={30}
        breakpoints={[{ maxWidth: 'md', cols: 1 }]}
      >
        <Flex className="flex_align_center">
          <Title order={2}>Assessment Form</Title>
        </Flex>
        <Flex className="flex_justify_end">
          <img id={'welcome-image'} src={evaluationImage} alt="welcome" />
        </Flex>
      </SimpleGrid>

      <Flex
        bg="#fff"
        className="evalution_question_box"
        p={{ base: 10, sm: 20 }}
        direction="row"
        wrap="wrap"
      >
        <Flex style={{ margin: "50px 0px", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ fontWeight: "bold", width: "150px" }}>Learner Name:</div>
            {isLoading ? <Skeleton height={16} width={180} mt={2} /> : <div>{ass ? ass.name : ''}</div>}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ fontWeight: "bold", width: "150px" }}>Learner NRIC:</div>
            {isLoading ? <Skeleton height={16} width={120} mt={2} /> : <div>{ass ? ass.learner_nricmask : ''}</div>}
          </div>
        </Flex>

        {isLoading ? (
          <AssessmentSkeleton />
        ) : (
        <form onSubmit={handleFormSubmit} style={{ width: '100%' }}>
          {ass && ass.assessment_description ? (
            <div>
              <p 
                dangerouslySetInnerHTML={{ __html: ass.assessment_description.replace(/\n/g, '<br />') }}
              />
            </div>
          ) : null}
          {ass && ass.questions && typeof ass.questions === 'object' ? (
            Object.values(ass.questions).map((question: any, index: number) => (
              <div key={question.id} style={{ marginBottom: '20px' }}>
                {!question.sub_id ? (
                  // Main Question (Without Sub-Questions)
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="form-control-label bold">
                          {/* {`${index + 1}. ${question.question}`} <span style={{ color: 'red' }}>*</span> */}
                          
                          <div>
                            {/* {`${index + 1}. `} */}
                            <span 
                              dangerouslySetInnerHTML={{ __html: question.question.replace(/\n/g, '<br />') }}
                            />
                            <span style={{ color: 'red' }}>*</span>
                          </div>
                        </label>
                        {question.upload_files ? (
                          <div style={{ border: '1px solid #dbdbdb', padding: '5px' }}>
                            {JSON.parse(question.upload_files).map((file, idx) => (
                              <img key={idx} src={file} alt={`upload-${idx}`} width="100%" />
                            ))}
                          </div>
                        ) : (
                          <textarea
                            name={`question[${question.id}]`}
                            className="form-control quiz-search-input"
                            placeholder="Answer ....."
                            rows={5}
                            defaultValue={question.answer || ""}
                            readOnly
                            style={{ backgroundColor: "#e9e9e9" }}
                          />
                        )}
                        <Box style={{ position: 'relative' }}>
                          <label className="form-control-label">Trainer Comment <span style={{ color: 'red' }}>*</span></label>
                          
                          <Radio.Group
                            name={`status[${question.parent_id}]`}
                            style={{ position: 'absolute', top: '2px', right: '0' }}
                            // value={form.values.status?.[`${question.parent_id}_${subQuestion.sub_id}`]} // Correct binding
                            onChange={(value) =>
                              form.setFieldValue(
                                `status.${question.parent_id}`,
                                value
                              )
                            }
                            {...form.getInputProps(`status.${question.parent_id}`)}
                          >
                            <Radio value="C" label="(C)" />
                            <Radio value="NYC" label="(NYC)" />
                          </Radio.Group>

                        </Box>
                        <textarea
                          name={`comment[${question.parent_id}]`}
                          className="form-control quiz-search-input"
                          placeholder="Comment ....."
                          rows={5}
                          {...form.getInputProps(`comments.${question.parent_id}`)}
                        />
                        {form.errors.comments?.[question.parent_id] && (
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {form.errors.comments[question.parent_id]}
                          </div>
                        )}
                        {form.errors.status?.[question.parent_id] && (
                          <div style={{ color: "red", fontSize: "12px" }}>
                            Please fill in question status (C) or (NYC)
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  // Question with Sub-Questions
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="form-control-label bold">
                          {/* {`${index + 1}. ${question.question}`} <span style={{ color: 'red' }}>*</span> */}
                          <div>
                            {/* {`${index + 1}. `} */}
                            <span 
                              dangerouslySetInnerHTML={{ __html: question.question.replace(/\n/g, '<br />') }}
                            />
                            {/* <span style={{ color: 'red' }}>*</span> */}
                          </div>
                        </label>
                        <table className="w100"
                          style={{
                            borderCollapse: 'collapse',
                            width: '100%',
                          }}
                        >
                          <tbody>
                            {question.assessment_question_options &&
                              question.assessment_question_options.map((subQuestion: any) => (
                                <tr key={subQuestion.id}>
                                  <td
                                    style={{
                                      border: '1px solid #bfbfbf',
                                      padding: '10px',
                                      verticalAlign: 'top',
                                      width: '50%',
                                    }}
                                  >
                                    <label className="form-control-label">
                                      <span 
                                        dangerouslySetInnerHTML={{ __html: subQuestion.sub_question.replace(/\n/g, '<br />') }}
                                      />
                                      {/* <span style={{ color: 'red' }}>*</span> */}
                                    </label>
                                  </td>
                                  <td
                                    style={{
                                      border: '1px solid #bfbfbf',
                                      padding: '10px',
                                      verticalAlign: 'top',
                                      width: '50%',
                                    }}
                                  >
                                    {subQuestion.upload_files ? (
                                      <div style={{ border: '1px solid #dbdbdb', padding: '5px' }}>
                                        {JSON.parse(subQuestion.upload_files).map((file, idx) => (
                                          <img key={idx} src={file} alt={`upload-${idx}`} width="100%" />
                                        ))}
                                      </div>
                                    ) : (
                                      <textarea
                                        name={`question[${question.parent_id}][${subQuestion.sub_id}]`}
                                        className="form-control quiz-search-input"
                                        placeholder="Answer ....."
                                        rows={5}
                                        defaultValue={subQuestion.answer || ""}
                                        readOnly
                                        style={{ backgroundColor: "#e9e9e9" }}
                                      />
                                    )}
                                    <Box style={{ position: 'relative' }}>
                                      <label className="form-control-label">
                                        Trainer Comment <span style={{ color: 'red' }}>*</span><br></br>(if applicable)
                                      </label>
                                      
                                      <Radio.Group
                                        name={`status[${question.parent_id}_${subQuestion.sub_id}]`}
                                        style={{ position: 'absolute', top: '2px', right: '0' }}
                                        // value={form.values.status?.[`${question.parent_id}_${subQuestion.sub_id}`]} // Correct binding
                                        onChange={(value) =>
                                          form.setFieldValue(
                                            `status.${question.parent_id}`,
                                            value
                                          )
                                        }
                                        {...form.getInputProps(`status.${question.parent_id}_${subQuestion.sub_id}`)}
                                      >
                                        <Radio value="C" label="(C)" />
                                        <Radio value="NYC" label="(NYC)" />
                                      </Radio.Group>
                                    </Box>
                                    <textarea
                                      name={`comment[${question.parent_id}_${subQuestion.sub_id}]`} // Combine IDs
                                      className="form-control quiz-search-input"
                                      placeholder="Comment ....."
                                      rows={5}
                                      defaultValue={subQuestion.comment || ""}
                                      {...form.getInputProps(`comments.${question.parent_id}_${subQuestion.sub_id}`)} // Use combined key
                                    />
                                    {form.errors.comments?.[`${question.parent_id}_${subQuestion.sub_id}`] && (
                                      <div style={{ color: "red", fontSize: "12px" }}>
                                        {form.errors.comments[`${question.parent_id}_${subQuestion.sub_id}`]}
                                      </div>
                                    )}
                                    {form.errors.status?.[`${question.parent_id}_${subQuestion.sub_id}`] && (
                                      <div style={{ color: "red", fontSize: "12px" }}>
                                        Please fill in question status (C) or (NYC)
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>No questions available</p>
          )}
                    
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="form-control-label bold" style={{ display: 'block' }}>Remarks by Assessor: </label>
                {isRemarkEmpty && suggestedRemark && (
                  <Flex
                    align="center"
                    gap="xs"
                    wrap="wrap"
                    px="sm"
                    py={6}
                    mt={4}
                    mb={6}
                    sx={{
                      background: '#e7f5ff',
                      borderLeft: '4px solid #228be6',
                      borderRadius: 6,
                      clear: 'both',
                    }}
                  >
                    <IconBulb size={20} color="#228be6" style={{ flexShrink: 0 }} />
                    <Text size="sm" sx={{ flex: 1, minWidth: 200 }}>
                      Suggestion: <b>{suggestedRemark}</b>
                    </Text>
                    <Button
                      type="button"
                      color="blue"
                      size="xs"
                      onClick={() => form.setFieldValue('assessment_comment', suggestedRemark)}
                    >
                      + Insert
                    </Button>
                  </Flex>
                )}
                <textarea
                  name={`assessment_comment`}
                  className="form-control quiz-search-input"
                  placeholder="Comment ....."
                  rows={5}
                  {...form.getInputProps(`assessment_comment`)}
                />
                {form.errors.assessment_comment && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {form.errors.assessment_comment}
                  </div>
                )}
              </div>
            </div>
          </div>
          
          <div style={{width:"100%", display:"flex", textAlign:"center", marginTop:"50px"}}>

            <div style={{width:"50%"}}>
              <p style={{textAlign:"center"}}>Trainer Signature</p>
              {ass && ass.trainer_signature ? (
                <div>
                  <img src={apiUrl + "/" + ass.trainer_signature} alt="trainer signature" />
                  <hr style={{width:"300px", borderTop:"1px solid #000000", textAlign:"center", margin:"auto"}} ></hr>
                  <p style={{width:"300px", textAlign:"center", margin:"auto"}}>{ ass.trainer_signature_date }</p>
                </div>
              ) : (
                <div>
                  <div>
                    <SignatureCanvas
                      ref={signatureRef}
                      penColor="black"
                      backgroundColor="#fff"
                      canvasProps={{
                        width: 300,
                        height: 200,
                        className: 'signature-canvas',
                      }}
                    />
                    <hr style={{width:"300px", borderTop:"1px solid #000000", textAlign:"center", margin:"auto"}} ></hr>

                    {form.errors?.signature && (
                      <span style={{ color: 'red', paddingTop: '4px' }}>
                        Please sign and confirm all result is correct
                      </span>
                    )}
                  </div>
                  <div style={{ textAlign: "center", width: "300px", margin:"auto" }}>
                    <GradientButton
                      mt="sm"
                      onClick={handleClearSignature}
                      style={{
                        margin: '10px',            // Optional: Custom margin for "Clear" button
                      }}
                    >
                      Clear
                    </GradientButton>
                    {/* <GradientButton
                      mt="sm"
                      onClick={handleSaveSignature}
                      style={{
                        margin: '10px',            // Optional: Custom margin for "Save" button
                      }}
                    >
                      Submit
                    </GradientButton> */}
                  </div>
                </div>
              )}
            </div>
            
            <div style={{width:"50%"}}>
              <p style={{textAlign:"center"}}>Learner Signature</p>
              {ass && ass.signature ? (
                <div>
                  <img src={apiUrl + "/" + ass.signature} alt="learner signature" />
                  <hr style={{width:"300px", borderTop:"1px solid #000000", textAlign:"center", margin:"auto"}} ></hr>
                  <p style={{width:"300px", textAlign:"center", margin:"auto"}}>{ ass.name }</p>
                  <p style={{width:"300px", textAlign:"center", margin:"auto"}}>{ ass.signature_date }</p>
                </div>
              ) : (
                <div>
                  <div style={{ height:"200px"}}>
                  </div>
                  <hr style={{width:"300px", borderTop:"1px solid #000000", textAlign:"center", margin:"auto"}} ></hr>

                </div>
              )}
            </div>
          </div>



          <Flex className="flex_justify_end" w="100%">
            <GradientButton type="submit" mt="sm" onClick={handleSubmit}>
              Submit
            </GradientButton>
          </Flex>
          {nycRows.length > 0 && <NycReminder rows={nycRows} />}
        </form>
        )}

      </Flex>
      <RemarkReviewModal
        opened={remarkModalOpen}
        rows={commentedRows}
        remark={remarkDraft}
        onRemarkChange={setRemarkDraft}
        onAdd={handleAddRemark}
        onSkip={continueSubmit}
        onCancel={() => setRemarkModalOpen(false)}
      />
    </Box>
  );
}
